import React, {useEffect} from "react";
import {Outlet, useParams} from "react-router-dom";
import {useSetAtom} from "jotai";
import {AppLayout} from "../AppLayout";
import {BaseFilterPanel} from "../panels/BaseFilterPanel";
import {routerCompanyIdAtom, routerFarmIdAtom, routerFieldIdAtom} from "../../store/routerStore";
import {useCompanyIdPersist} from "../../hooks/companyIdPersistHooks";
import {useCompany} from "../../hooks/companiesHooks";

export const InsightsPage: React.FC = () => {
    useCompany();
    useRouterParamsStoreSync();
    useCompanyIdPersist();

    return (
        <AppLayout sidePanel={<BaseFilterPanel basePath="insights" />}>
            <Outlet />
        </AppLayout>
    );
};

/**
 * Retrieves Router (URL path) params and sets them in Store
 */
const useRouterParamsStoreSync = () => {
    const {companyId, farmId, fieldId} = useParams();
    const setRouterCompanyId = useSetAtom(routerCompanyIdAtom);
    const setRouterFarmId = useSetAtom(routerFarmIdAtom);
    const setRouterFieldId = useSetAtom(routerFieldIdAtom);
    useEffect(() => {
        setRouterCompanyId(companyId);
    }, [companyId, setRouterCompanyId]);

    useEffect(() => {
        setRouterFarmId(farmId);
    }, [farmId, setRouterFarmId]);

    useEffect(() => {
        setRouterFieldId(fieldId);
    }, [fieldId, setRouterFieldId]);
};
